import styled from 'styled-components';
import arrowBlue from '../../../images/arrow-blue.png';

export const RightMenuPanelContainer = styled.div`
  float: left;
  width: 100%;
  @media (max-width: 991px) {
    width: 320px;
  }
`;

export const LiContainer = styled.li`
  position: relative;
  z-index: 2;
  margin: 0px;
  padding: 0px;
  list-style: none;
  background: none;
  :hover {
    background: #fff;
  }
`;

export const LinkStyle = styled.a`
  display: block;
  padding: 8px 0px 8px 30px;
  font-size: 14px;
  font-family: 'Gotham-Medium', arial, sans-serif;
  line-height: 18px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #083a81;
  background-size: 7px auto;
  text-decoration: none;
  text-align: left;
  transition: background-position 0.15s ease-out;
  @media (max-width: 991px) {
    text-align: center !important;
  }
  :hover {
    background: url(${arrowBlue}) no-repeat 1px 9px;
    background-size: 7px auto;
    background-position: 12px 12px;
    color: #0397d6;
  }
`;

export const ListContainer = styled.ul`
  margin-left: 0px;
  padding-left: 0px;
  margin-bottom: 0 !important;
  padding-bottom: 20px;
`;

// submenu

export const SubMenuList = styled.ul`
  position: relative;
  margin: 0;
  padding: 0;
  @media (max-width: 991px) {
    position: relative;
  }
`;
export const SubMenuListItem = styled.p`
  position: relative;
  z-index: 2;
  margin: -5px 0 0 10px;
  padding: 0px;
  list-style: none;
  background: none;
`;
export const SubMenuAnchor = styled.a`
  display: block;
  padding: 8px 0px 8px 30px;
  font-size: 12px;
  font-family: 'Gotham-Medium', arial, sans-serif;
  line-height: 12px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #083a81;
  background-size: 7px auto;
  text-decoration: none;
  text-align: left;
  transition: background-position 0.15s ease-out;
  cursor: pointer;
  :hover {
    background: url(${arrowBlue}) no-repeat 1px 9px;
    background-size: 7px auto;
    background-position: 20px 8px;
    color: #0397d6;
  }
`;
